/**
 * O bloco do Cliente 360: um cartão com título, a ação dele no canto e o
 * aviso de dado defasado.
 *
 * ── A ação mora no título ────────────────────────────────────────────────
 *
 * "Editar" no canto do bloco, e não solto embaixo da ficha (16/10/2026): com
 * quatro blocos na aba "Cadastro", o botão embaixo de cada um ficava a alturas
 * diferentes, e o da ficha comprida sumia da vista. No título ele está sempre
 * no mesmo lugar, e diz de qual bloco é.
 *
 * Saiu do `cliente-360.tsx` para os blocos da clínica (ficha, convênio) se
 * montarem sozinhos: são eles que sabem quando a ação aparece.
 */

import type { ReactNode } from 'react';
import { Defasado } from '@/shared/ui/estados/estados';

export function Bloco({
  titulo,
  contagem,
  frescor,
  largo = false,
  acao,
  children,
}: {
  titulo: string;
  contagem?: number | null;
  /** A linha inteira da grade, para o bloco grande não ficar espremido ao lado dos outros. */
  largo?: boolean;
  frescor?: { stale: boolean; projetado_em: string | null } | undefined;
  /** A ação do bloco, no canto do título. Some enquanto o bloco está em edição. */
  acao?: ReactNode;
  children: ReactNode;
}): ReactNode {
  return (
    <section className={largo ? 'c360__bloco c360__bloco--largo' : 'c360__bloco'}>
      <header className="c360__cabecalho">
        <h2>{titulo}</h2>
        {contagem != null && <span className="c360__contagem">{contagem}</span>}
        {acao && <span className="c360__bloco-acao">{acao}</span>}
      </header>

      {/* Por bloco, não no topo da tela: cada um degrada sozinho, e uma faixa
          global faria desconfiar do que está certo. */}
      {frescor?.stale && <Defasado projetadoEm={frescor.projetado_em} origem="Este bloco" />}

      {children}
    </section>
  );
}
